import { AppThunk } from 'store';
import { StatusLoading } from 'common/constants';

import slice from '../reducer/slice';

type TOperation = (status: StatusLoading, isAutoscaling?: boolean) => AppThunk;

const { setIsLoadingAllStations } = slice.actions;

const operation: TOperation = (status) => async (dispatch) => {
  dispatch(setIsLoadingAllStations(status));
};

export default operation;
